import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Stepper,
  Step,
  StepLabel,
  Table,
  TableHead, TableRow, TableCell, TableBody, Checkbox,
  useMediaQuery,
  Divider,
  useTheme
} from '@mui/material';
import {useState, Fragment, useMemo, ReactNode, useEffect} from 'react';
import {GridColDef} from '@mui/x-data-grid';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Styles from '../theme/commonCss/Styles';
import FilterData from './filterData';
import Ajv from 'ajv';
import Modal from './Modal';
import {get, uniqBy} from 'lodash';
import {Node, Edge} from '@reactflow/core';
import { Position} from "reactflow";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {NodeItem} from "./FlowRenderer/react-flow";
import * as uuid from "uuid";
import { useOutletContext } from 'react-router-dom';

interface GET_TAGS_KEY {
  useCase: string;
  factory: string;
}

const getTagsKey: GET_TAGS_KEY = {
  useCase: 'use_case_tags',
  factory: 'factory_tags',
};

const getFormDetails = {
  factory: {
    title: 'Shop floor',
    tag: 'factory_tags',
  },
  useCase: {
    title: 'Use Case',
    tag: 'use_case_tags',
  },
};

const useCaseStyles = {
 input:{
  '&.MuiGrid-item': {
     p: '0px !important',
    },
   },
};

const UseCaseFormModal = ({
  data,
  setData,
  tags,
  setTags,
  isModalOpen,
  title,
  isEdit,
  closeModal = () => {
  },
  onSave = () => {
  },
  ontologyData,
  metaDataSchema,
  dataSchema,
  uiSchema,
  isFrom,
  factories,
  gateways
}: any) => {
  const themeData: any = useTheme();
  const ajv = new Ajv();
  const [ajvErrors, setAjvErrors] = useState<any>({});
  const formDetails = get(getFormDetails, isFrom, {});
  const tags_key = get(formDetails, 'tag', '');

  const responsiveSize = useMediaQuery('(max-width:900px)');

  const handleChange = (e: any) => {
    const {name, value} = e.target;
    setData({...data, [name]: value});
  };

  const addGatewayTagRow = (event: any, len: number) => {
    setTags((prevItem: any) => {
      return [
        ...prevItem,
        {
          id: len + 1,
          key: '',
          value: '',
        },
      ];
    });
  };

  // const deleteRowItem = (event: any, rows: any) => {
  //   setTags(tags.filter((data: any) => data.id !== rows.id));
  // };

  const deleteRowItem = (event: any, rows: any) => {
    setTags(
      tags
        .filter((data: any) => data.id !== rows.id)
        .map((item: any, index: number) => {
          return {...item, id: index + 1};
        })
    );
  };

  const changeSchemaBuilderValue = (e: any, row: any) => {
    const {name, value} = e.target;
    const updatedSchema = tags.map((schema: any) => {
      if (schema.id === row.id) {
        return {
          ...schema,
          [name]: value,
        };
      }
      return schema;
    });
    setTags(updatedSchema);
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    let ajvSchema: any = {...dataSchema};

    if (tags.length) {
      ajvSchema = {
        ...dataSchema,
        properties: {
          ...dataSchema.properties,
          [tags_key]: {
            type: 'array',
            items: tags.map((item: any) => metaDataSchema),
          },
        },
        required: [...dataSchema.required, tags_key],
      };
    }

    const reqParams = {
      ...data,
      [tags_key]: tags,
    };

    const validate = ajv.compile(ajvSchema);

    if (validate({...reqParams})) {
      // const edges = getConnectedEdges(selectedNodes, mergedConfig.edges);
      const ui_config = {
        nodes: [clouds[0] ?? {
          id: 'cloud',
          type: 'cloudNode',
          draggable: false,
          position: {x: 10, y: 50},
          data: {},
        }, ...selectedNodes],
        ...(selectedFlows.length && { flows: selectedFlows })
      };
      reqParams.ui_config = ui_config;
      setStep(0);
      onSave({
        ...reqParams,
        status: 'draft',
      });
      closeModal();
      setAjvErrors({});
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  const columns: GridColDef[] = [
    {
      field: 'key',
      headerName: 'Key',
      sortable: true,
      filterable: false,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <TextField
            variant="outlined"
            size="small"
            name={params.field}
            value={tags.find((schema: any) => schema.id === params.id)[params.field]}
            onChange={(e: any) => changeSchemaBuilderValue(e, params.row)}
            error={
              ajvErrors.instancePath && ajvErrors.instancePath.includes(`${tags_key}/${params.id - 1}/${params.field}`)
            }
          />
        );
      },
    },
    {
      field: 'value',
      headerName: 'Value',
      flex: 1,
      filterable: false,
      renderCell: (params: any) => {
        return (
          <TextField
            variant="outlined"
            name={params.field}
            size="small"
            value={tags.find((schema: any) => schema.id === params.id)[params.field]}
            onChange={(e: any) => changeSchemaBuilderValue(e, params.row)}
            error={
              ajvErrors.instancePath && ajvErrors.instancePath.includes(`${tags_key}/${params.id - 1}/${params.field}`)
            }
          />
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 80,
      sortable: false,
      filterable: false,
      align: 'center',
      renderCell: (params: any) => {
        return <DeleteOutlineIcon fontSize="small" fontWeight="normal" onClick={(e) => deleteRowItem(e, params.row)}/>;
      },
    },
  ];

  const getOntoSelectedValue = (data: any) => {
    setData((remaining: any) => ({...remaining, ...data, onto_manage_id: data.onto_manage_id}));
  };

  const mergedConfig = useMemo(() => {
    const nodes = factories.flatMap((factory: any) => uniqBy(factory?.ui_config?.nodes ?? [], 'id')) as Node[];
    const edges = factories.flatMap((factory: any) => uniqBy(factory?.ui_config?.edges ?? [], 'id')) as Edge[];
    return {nodes, edges};
  }, [factories]);

  const [selectedNodes, setSelectedNodes] = useState<Node[]>(data?.ui_config?.nodes ?? []);
  const [selectedFlows, setSelectedFlows] = useState<Node[]>(data?.ui_config?.flows ?? []);
  const [step, setStep] = useState(0);

  useEffect(() => {
    setSelectedNodes(data?.ui_config?.nodes ?? [])
    setSelectedFlows(data?.ui_config?.flows ?? [])
  }, [data]);

  const clouds = useMemo(() => (mergedConfig.nodes.filter((node: Node) => node.type === 'cloudNode')), [mergedConfig]);
  // const gateways: Node[] = useMemo(() => uniqBy(mergedConfig.nodes.filter((node: Node) => node.type === 'edgeNode'), 'data.gateway_id'), [mergedConfig]);
  const assets = useMemo(() => (mergedConfig.nodes.filter((node: Node) => node.type === 'assetNode')), [mergedConfig]);
  const machines = useMemo(() => (mergedConfig.nodes.filter((node: Node) => node.type === 'machineNode')), [mergedConfig]);

  const connectedAssets = useMemo(() => assets.filter((asset: Node) => {
    return selectedNodes.find((node: Node) => node.id === (asset as unknown as NodeItem).connectedTo)
    // return (assets as unknown[] as NodeItem[]).filter((asset: NodeItem) => selectedNodes.find((node: Node) => node.id === asset.connectedTo)).length > 0;//getIncomers(asset, mergedConfig.nodes, mergedConfig.edges);
    // return assets.find((incomer: Node) => selectedNodes.find((node: Node) => node.id === incomer.id || (!!node.data.gateway_id && node.data.gateway_id === incomer.data.gateway_id)));
  }), [selectedNodes, assets, mergedConfig]);


  const connectedMachines = useMemo(() => machines.filter((machine: Node) => {
    return selectedNodes.find((node: Node) => node.id === (machine as unknown as NodeItem).connectedTo); //getIncomers(machine, mergedConfig.nodes, mergedConfig.edges);
    // return incomers.find((incomer: Node) => selectedNodes.find((node: Node) => node.id === incomer.id));
  }), [selectedNodes, machines, mergedConfig]);
  // const config = useMemoo(() => ([]), [gateways, assets, machines]);

  return (
    <Modal title={title} open={isModalOpen} handleClose={closeModal}>
      <Card sx={Styles.card}>
        <CardContent component="form" onSubmit={handleSubmit}>
          <CardHeader
            title={`Select Ontology for ${formDetails.title}`}
            titleTypographyProps={Styles.title}
          />
          <Divider/>
          <Grid container spacing={2} sx={{marginTop: '12px', marginBottom: '24px', paddingLeft: '16px'}}>
            {uiSchema.map(({label, name, type}: any) => {
              if (type === 'input') {
                return (
                  <Fragment key={name}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={4}
                      sx={{
                        ...Styles.gridItem,
                        '&.MuiGrid-item': {
                          padding: responsiveSize ? '12px 0 0 0' : '22px 0px 0px !important',
                          justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                        },
                      }}
                    >
                      <Typography sx={{...Styles.inputLabel, color: themeData.palette.text.primary }}>{label}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={8} sx={useCaseStyles.input}>
                      <TextField
                        sx={{
                          '&.MuiTextField-root': {
                            margin: '0px',
                            padding: responsiveSize ? '4px 0px 12px' : '12px 0px',
                          },
                        }}
                        margin='normal'
                        fullWidth
                        id={name}
                        onChange={handleChange}
                        name={name}
                        autoComplete={name}
                        autoFocus
                        variant='outlined'
                        value={data[name]}
                        size='small'
                        helperText={
                          ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message
                        }
                        error={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
                      />
                    </Grid>
                  </Fragment>
                );
              } else if (type === 'select') {
                return (
                  <Grid container spacing={1} sx={{ marginTop: '0px', borderBottom:`1px solid ${themeData.palette.customBorderColor.main}`, marginLeft: '0px', paddingBottom:'12px' }}>
                    <FilterData
                      ontologyData={ontologyData}
                      showLayout={false}
                      onOntoFilterChange={getOntoSelectedValue}
                      isError={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
                    />
                  </Grid>
                );
              } else {
                return <></>;
              }
            })}
            <Box sx={{width: '100%'}}>
              <Stepper activeStep={step}>
                {['Select Gateways'].map((label, index) => {
                  const stepProps: { completed?: boolean } = {};
                  const labelProps: {
                    optional?: ReactNode;
                  } = {};
                  // if (isStepOptional(index)) {
                  //   labelProps.optional = (
                  //     <Typography variant="caption">Optional</Typography>
                  //   );
                  // }
                  // if (isStepSkipped(index)) {
                  //   stepProps.completed = false;
                  // }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {[
                <Box sx={{width: '100%'}}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Selected</TableCell>
                        <TableCell>Gateway</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {gateways.filter((gw: any) => gw.data_transfer_status === 'provisioned').map((gateway: any) => <TableRow>
                        <TableCell>
                          <Checkbox
                            checked={!!selectedNodes.find((node: Node) => node?.data?.gateway_id === gateway.gateway_id)}
                            onChange={(e, v) => setSelectedNodes((nodes: Node[]) => {
                              if (!v) {
                                return nodes.filter((node: Node) => node?.data?.gateway_id !== gateway.gateway_id);
                              } else {
                                let node = {
                                  id: 'edge-' + gateway.gateway_id,
                                  type: 'edgeNode',
                                  display: gateway.display,
                                  data: {...gateway},
                                  sourcePosition: Position.Right,
                                  targetPosition: Position.Left,
                                  connectedTo: 'cloud',
                                };
                                return [...nodes, {
                                  ...node,
                                  id: node.id ?? `${node.type}-${uuid.v4().toString()}`,
                                  sourcePosition: node.sourcePosition,
                                  targetPosition: node.targetPosition,
                                  position: {
                                    x: 0,
                                    y: 0,
                                  },
                                  draggable: false,
                                  type: node.type,
                                  data: {
                                    label: node.display,
                                    type: node.id,
                                    ...node.data
                                  },
                                }];
                              }
                            })}
                          />
                        </TableCell>
                        <TableCell>{gateway.gateway_name}</TableCell>
                      </TableRow>)}
                    </TableBody>
                  </Table>
                </Box>,
                <Box sx={{width: '100%', p: 2}}>
                  {connectedAssets.map((asset: Node) => <Accordion sx={{p: 1, boxShadow: 'none'}}>
                    <AccordionSummary sx={{p: 0}} expandIcon={<ExpandMoreIcon />}>
                      <Typography>{asset.data.name} ({asset.data.ip})</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Selected</TableCell>
                            <TableCell>Asset</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {asset.data.options.map((component: any) => <TableRow>
                            <TableCell>
                              <Checkbox
                                disabled={!asset.data.enabled || !component.enabled}
                                checked={!!selectedNodes.find((node: Node) => node.id === asset.id)?.data?.options?.find((c: any) => c.id === component.id)}
                                onChange={(e, v) => setSelectedNodes((nodes: Node[]) => {
                                  const foundAsset = nodes.find((node: Node) => node.id === asset.id);
                                  if (!v) {
                                    if(foundAsset?.data?.options.find((comp: any) => comp.id === component.id)) {
                                      if(foundAsset?.data?.options?.length > 1) {
                                        return nodes.map((node: Node) => {
                                          if(node.id === asset.id) {
                                            node.data.options = node.data.options.filter((comp: any) => comp.id !== component.id);
                                          }
                                          return node;
                                        })
                                      }
                                    }
                                    return nodes.filter((node: Node) => node.id !== asset.id);
                                  } else {
                                    if(foundAsset) {
                                      return nodes.map((node: Node) => {
                                        if(node.id === asset.id) {
                                          node.data.options = [...node.data.options, component]
                                        }
                                        return node;
                                      })
                                    } else {
                                      return [...nodes, {
                                        ...asset, data: {...asset.data, options: [component]}
                                      }];
                                    }
                                  }
                                })}
                              />
                            </TableCell>
                            <TableCell>{component.component_name}</TableCell>
                          </TableRow>)}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>)}
                </Box>,<Box sx={{width: '100%'}}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Selected</TableCell>
                        <TableCell>Gateway</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {connectedMachines.map((machine: Node) => <TableRow>
                        <TableCell>
                          <Checkbox
                            checked={!!selectedNodes.find((node: Node) => node.id === machine.id)}
                            onChange={(e, v) => setSelectedNodes((nodes: Node[]) => {
                              if (!v) {
                                return nodes.filter((node: Node) => node.id !== machine.id);
                              } else {
                                return [...nodes, machine];
                              }
                            })}
                          />
                        </TableCell>
                        <TableCell>{machine.data.machine_name}</TableCell>
                      </TableRow>)}
                    </TableBody>
                  </Table>
                </Box>
              ][step]}
            </Box>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} textAlign={'center'}>
              <Button variant="outlined" sx={{m: 2}} onClick={step === 0 ? closeModal : () => {
                setStep(s => s - 1);
              }}>
                {step === 0 ? "Cancel" : "Back"}
              </Button>
              <Button variant="contained" type={/*step === 3 ? */"submit"/* : "button"*/}
                      onClick={step > -1 ? () => setStep(0) : () => setStep(s => s + 1)}>
                {step === 0 ? "Save" : "Next"}
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default UseCaseFormModal;
